import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SidebarService } from '@core/services/presenters/sidebar.service';

@Component({
  selector: 'app-layout-sidebar-item-group',
  imports: [CommonModule],
  templateUrl: './layout-sidebar-item-group.component.html',
})
export class LayoutSidebarItemGroupComponent {
  constructor(readonly sidebarService: SidebarService) {}
}
